export default __webpack_public_path__ + "../staticImages/fallback-bodega.jpg";